import { z } from 'zod';

import { catchAndLog } from './issue-logging';
import { metadataSchema } from './metadata';

const customConfig = z
	.object({
		mofaTenant: z.string().nullish(),
		mofaStandaloneTenant: z.string().nullish(),
		hostHeader: z.string().nullish()
	})
	.passthrough();

const credentials = z.object({
	username: z.string(),
	password: z.string()
});

const serviceConfig = z.object({
	urlOrigin: z.string().catch(''), // allow for default origin mechanism
	urlPath: z.string().optional().catch(undefined),
	tenantCommercial: z.string().optional().catch(undefined),
	tenantPrivate: z.string().optional().catch(undefined),
	customConfig: customConfig.optional().catch(undefined),
	credentials: credentials.optional().catch(undefined)
});

// Individual service configs should not cause the entire response to be
// invalidated. We don't want to reject the response only because service
// configs that we don't even plan to use are invalid.
export const zodServiceConfigs = z.object({
	meta: metadataSchema.optional(),
	configs: z.record(serviceConfig.optional().catch(catchAndLog('service-config', undefined))).transform(record => {
		const validatedValues: Record<string, NonNullable<(typeof record)[string]>> = {};

		for (const [key, value] of Object.entries(record)) {
			if (value) {
				validatedValues[key] = value;
			}
		}

		return validatedValues;
	})
});

export type ZodServiceConfigs = z.infer<typeof zodServiceConfigs>;
